module.exports = __webpack_public_path__ + "img/background_power.0ef74027.png";